"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowIcon16 = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("../../build-svg-icon");
exports.LowIcon16 = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement("path", { d: "M2.07266 6.10942L6.33563 12.5039C7.12727 13.6913 8.87218 13.6913 9.66383 12.5039L13.9268 6.10942C14.8129 4.78031 13.8601 3.00002 12.2627 3.00002H3.73676C2.13937 3.00002 1.18659 4.78031 2.07266 6.10942Z", fill: "currentColor" }), 'LowIcon16', { viewBox: '0 0 16 16' });
exports.default = exports.LowIcon16;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG93SWNvbjE2LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vZGVzaWduLXN5c3RlbS1pY29ucy91aS1pY29ucy8xNi9Mb3dJY29uMTYudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGdEQUEwQjtBQUMxQix1REFBb0Q7QUFFdkMsUUFBQSxTQUFTLEdBQUcsSUFBQSw2QkFBWSxFQUNuQyx3Q0FDRSxDQUFDLEVBQUMsMk1BQTJNLEVBQzdNLElBQUksRUFBQyxjQUFjLEdBQ25CLEVBQ0YsV0FBVyxFQUNYLEVBQUUsT0FBTyxFQUFFLFdBQVcsRUFBRSxDQUN6QixDQUFDO0FBRUYsa0JBQWUsaUJBQVMsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/design-system-icons/ui-icons/16/LowIcon16.js
// module id = 5095
// module chunks = 25